export default __webpack_public_path__ + "static/media/advisor-mode.2ed4f3b2.svg";